var _path, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H33C49.5685 0 63 13.4315 63 30C63 46.5685 49.5685 60 33 60H30C13.4315 60 0 46.5685 0 30Z",
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5109_7027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5091 31.8307V16.8962C46.5091 15.5568 45.4468 14.4668 44.1409 14.4668H18.8806C17.5747 14.4668 16.5124 15.5568 16.5124 16.8962V31.8307C15.5955 32.1577 14.9336 33.0257 14.9336 34.0534V34.2015C14.9336 35.5074 15.9959 36.5696 17.3018 36.5696H18.6089L16.8562 42.4114C16.7102 42.8986 16.8003 43.4128 17.1044 43.821C17.4082 44.2291 17.8741 44.4635 18.3833 44.4635C18.9904 44.4635 19.537 44.1258 19.8091 43.5824L23.3155 36.5696H39.999L43.5057 43.5828C43.7774 44.1259 44.324 44.4635 44.9314 44.4635C45.4402 44.4635 45.9062 44.2295 46.2099 43.821C46.5141 43.4128 46.6042 42.899 46.4581 42.411L44.7055 36.5696H45.7196C47.0255 36.5696 48.0878 35.5074 48.0878 34.2015V34.0534C48.0878 33.0257 47.4259 32.1576 46.5091 31.8307ZM18.0912 16.8962C18.0912 16.4272 18.4454 16.0456 18.8806 16.0456H44.1409C44.5761 16.0456 44.9303 16.4272 44.9303 16.8962V31.6853H18.0912V16.8962ZM18.3972 42.8758C18.3959 42.8784 18.394 42.8807 18.3915 42.8822C18.3891 42.8838 18.3862 42.8847 18.3833 42.8847L18.3687 42.865L20.2574 36.5696H21.5501L18.3972 42.8758ZM44.9434 42.8785C44.9388 42.8847 44.9368 42.8847 44.9314 42.8847L41.7643 36.5696H43.0566L44.9434 42.8785ZM46.5091 34.2014C46.5091 34.6366 46.1548 34.9908 45.7197 34.9908H17.3018C16.8666 34.9908 16.5124 34.6366 16.5124 34.2014V34.0534C16.5124 33.6183 16.8666 33.264 17.3018 33.264H45.7196C46.1548 33.264 46.509 33.6183 46.509 34.0534V34.2014H46.5091Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3215 28.6303L41.1277 18.8647L39.8945 17.8789L33.0677 26.4192L27.2756 21.9235L26.3075 23.1706L26.31 23.1726L21.8945 28.8839L23.1436 29.8495L27.5572 24.1406L32.6502 28.0936L33.3215 28.6303Z",
    fill: "#0B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5109_7027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11.5 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessManage);
export default __webpack_public_path__ + "static/media/success-manage.6529b485f85eeeaf36f645e1261c0a9e.svg";
export { ForwardRef as ReactComponent };